import { Component, OnInit } from '@angular/core';
// import { NgbModal,ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
// import { from, Subject } from 'rxjs';
import { Router } from '@angular/router';
import { APIService } from '../../api.service';


@Component({
  selector: 'app-tags',
  templateUrl: './tags.component.html',
  styleUrls: ['./tags.component.scss']
})
export class TagsComponent implements OnInit {
 
agencyData: any = [];
jarvisData: any = []; 
TagsDataArry: any = [];

  constructor(private router: Router,private apiService: APIService) {
   }

  ngOnInit(): void {
    
    let agencyData = this.apiService.getCookie("M");
    if (agencyData) {
      this.agencyData = JSON.parse(agencyData);
    }
    var jarvis = this.apiService.getCookie("Jarvis");
    if (jarvis) {
      this.jarvisData = JSON.parse(jarvis);
    }

   this.getData();
  }


  
  // getHSN NO Code() - get all HSN/NO Code from database
  getData(){
    let myParams = [{
        myUserID: this.jarvisData[0].UserID,
        myToken: this.jarvisData[0].WebToken,
        forAgencyID: this.jarvisData[0].AgencyIDs,
        myAgencyIDs: this.jarvisData[0].AgencyIDs,
        ForERPAgencyID: this.agencyData[0].ERPAgencyID,
        myLastSyncDT: null,
        isWeb: true,
        actionType: 'getConfig',
        moduleID: 6,
        data: ''
    }];
    this.apiService.getData(myParams, this.successResp.bind(this), this.failureResp.bind(this));
    }
  
    //successResp - success  get handler
    successResp(res: any) {
      if (res.error) {
      }
      else {
          if (res) {
              var reponseData = JSON.parse(res.updatePackage);
              if (reponseData.Table2) {
    
                let tempData: any = [];
                tempData = reponseData.Table2[0].ItemTags.split(",");
               
                  for(let j = 0; j < tempData.length; j++){
                      if(tempData[j] != ''){
                        let temp = {
                          name : tempData[j]
                        }
                        this.TagsDataArry.push(temp)
                      }
                    } 
             }
          }
      }
  }

  //failureResp - failure handler
  failureResp(res: any) {
    if (res.error) {
    }
  }

  DeleteTags(ind: number){
    if(confirm("Are you sure delete this tags?")) {
      this.TagsDataArry.splice(ind, 1);
      this.getData();
    }
  }

  BackTOInvetory(){
  this.router.navigate(['Stock']);
  }
}




